export default __webpack_public_path__ + "static/media/136.db61ad0a.png";